import React from 'react';

const Loading = () => {
    return (
        <div className='flex h-screen justify-center items-center'>
            <button className="btn loading">loading</button>
        </div>
    );
};

export default Loading;